import jstz from 'jstz';
window.findTimeZone = () => jstz.determine().name();
